var echarts = require('echarts');
require('./china')

//首页在线情况环图
export const onlineStatusChart = (p) => {
    var myChart = echarts.init(document.querySelector(p.doc));
    let value = p.data;
    var option = {
        title: {
            subtext: value + "%",
            text: '在线',
            x: "center",
            y: "30%",
            textStyle: {
                fontSize: 14,
                color: '#fff'
            },
            subtextStyle: {
                fontSize: 17,
                fontWeight: 'bold',
                color: p.type == 1 ? "#EDB941" : '#7194F3'
            }
        },
        series: [{
                name: "当月任务故障率",
                type: "pie",
                radius: ["80%", "60%"],
                silent: true,
                clockwise: true,
                startAngle: 162,
                z: 0,
                zlevel: 0,
                label: {
                    normal: {
                        position: "center"
                    }
                },
                data: [{
                        value: 100 - value,
                        name: "",
                        itemStyle: {
                            normal: {
                                color: 'rgba(255,255,255,0.5)'
                            }
                        }
                    },
                    {
                        value: value,
                        name: "",
                        label: {
                            normal: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: p.type == 1 ? "#EDB941" : '#7194F3'
                            }
                        }
                    }
                ]
            },
            {
                name: "",
                type: "gauge",
                radius: "80%",
                center: ["50%", "50%"],
                startAngle: 0,
                endAngle: 359.9,
                splitNumber: 8,
                hoverAnimation: true,
                axisTick: {
                    show: false
                },
                splitLine: {
                    length: "26%",
                    lineStyle: {
                        width: 3,
                        color: '#000'
                    }
                },
                axisLabel: {
                    show: false
                },
                pointer: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        opacity: 0
                    }
                },
                detail: {
                    show: false
                },
                data: []
            }
        ]
    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//首页近一年销售统计柱图
export const homeXiaoShou = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            transitionDuration: 0,
        },
        legend: {
            show: true,
            right: '5px',
            top: '0px',
            itemWidth: 9,
            itemHeight: 9,
            textStyle: {
                color: 'white',
                fontSize: 12
            },
        },
        grid: {
            left: '0%',
            right: '1%',
            bottom: '1%',
            top: '12%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ccc'
                }
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: true,
                color: 'white',
            },
            data: p.date.reverse(),
        },
        yAxis: {
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dashd',
                    color: '#ccc',
                    opacity: .6
                }
            },
            type: 'value',
            minInterval: 1,
            show: true,
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: true,
                color: 'white',
                interval: 0
            },
            axisLine: {
                lineStyle: {
                    color: '#ccc'
                }
            },
            data: []
        },
        series: [{
                label: {
                    show: false,
                    position: ['4%', '20%'],
                    color: 'white'
                },
                name: '塔机',
                type: 'bar',
                barWidth: 12,
                barCategoryGap: 10,
                itemStyle: {
                    opacity: 0.9,
                    color: '#EDB941'
                },
                data: p.saleTower.reverse()
            },
            {
                label: {
                    show: false,
                    position: ['4%', '20%'],
                    color: 'white'
                },
                name: '升降机',
                type: 'bar',
                barWidth: 12,
                barCategoryGap: 10,
                itemStyle: {
                    opacity: 0.9,
                    color: '#7194F3'
                },
                data: p.saleLifter.reverse()
            },
        ]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//首页告警违章仪表盘图
export const homeYibiao = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));

    var getvalue = p.data;
    var getmax = getvalue + 100;

    var option = {
        title: [{
            text: p.data,
            bottom: '4%',
            x: 'center',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 20,
                color: p.color
            }
        }],
        angleAxis: {
            show: false,
            max: getmax * 360 / 270, //-45度到225度，二者偏移值是270度除360度
            type: 'value',
            startAngle: 225, //极坐标初始角度
            splitLine: {
                show: false
            }
        },
        barMaxWidth: 10, //圆环宽度
        radiusAxis: {
            show: false,
            type: 'category',
        },
        //圆环位置和大小
        polar: {
            center: ['50%', '50%'],
            radius: '110%'
        },
        series: [{
                type: 'bar',
                data: [{ //上层圆环，显示数据
                    value: getvalue,
                    itemStyle: {
                        color: p.color,
                    },
                }],
                barGap: '-100%', //柱间距离,上下两层圆环重合
                coordinateSystem: 'polar',
                roundCap: true, //顶端圆角
                z: 3 //圆环层级，同zindex
            },
            { //下层圆环，显示最大值
                type: 'bar',
                data: [{
                    value: getmax,
                    itemStyle: {
                        color: p.color,
                        opacity: 0.4,
                        borderWidth: 0,
                    },
                }],
                barGap: '-100%',
                coordinateSystem: 'polar',
                roundCap: true,
                z: 1
            },
            //仪表盘
            {
                type: 'gauge',
                startAngle: 225, //起始角度，同极坐标
                endAngle: -45, //终止角度，同极坐标
                axisLine: {
                    show: false,
                },
                splitLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    show: false
                },
                splitLabel: {
                    show: false
                },
                pointer: { // 分隔线
                    shadowColor: 'auto', //默认透明
                    shadowBlur: 5,
                    length: '55%',
                    width: "2",
                },
                itemStyle: {
                    color: p.color,
                    borderColor: p.color,
                    borderWidth: 2
                },
                detail: {
                    formatter: function(params) {
                        return p.text;
                    },
                    color: '#fff',
                    fontSize: 13,
                    offsetCenter: [0, '50%'],
                },
                title: {
                    show: false
                },
                data: [{
                    value: getvalue,
                }],
                max: getmax
            }, {
                name: '外部刻度',
                type: 'gauge',
                //  center: ['20%', '50%'],
                radius: '73%',
                min: 0, //最小刻度
                max: getmax, //最大刻度
                splitNumber: 10, //刻度数量
                startAngle: 225,
                endAngle: -45,
                axisLine: {
                    show: true,
                    lineStyle: {
                        width: 1,
                        color: [
                            [1, 'rgba(0,0,0,0)']
                        ]
                    }
                }, //仪表盘轴线
                axisLabel: {
                    show: false,
                    color: p.color,
                    distance: 25,
                }, //刻度标签。
                axisTick: {
                    show: true,
                    splitNumber: 6,
                    lineStyle: {
                        color: p.color, //用颜色渐变函数不起作用
                        width: 2,
                    },
                    length: -8
                }, //刻度样式
                splitLine: {
                    show: false,
                    length: -10,
                    lineStyle: {
                        color: p.color, //用颜色渐变函数不起作用
                    }
                }, //分隔线样式
                detail: {
                    show: false
                },
                pointer: {
                    show: false
                },
            }, { //指针外环
                "type": 'pie',
                "hoverAnimation": false,
                "legendHoverLink": false,
                "radius": ['11%', '16%'],
                "z": 10,
                "label": {
                    "normal": {
                        "show": false
                    }
                },
                "labelLine": {
                    "normal": {
                        "show": false
                    }
                },
                "data": [{
                    "value": 100,
                    itemStyle: {
                        normal: {
                            color: p.color,
                        }
                    }
                }]
            },
            { //指针内环
                "type": 'pie',
                "hoverAnimation": false,
                "legendHoverLink": false,
                "radius": ['0%', '10%'],
                "z": 10,
                "label": {
                    "normal": {
                        "show": false
                    }
                },
                "labelLine": {
                    "normal": {
                        "show": false
                    }
                },
                "data": [{
                    "value": 100,
                    itemStyle: {
                        normal: {
                            color: "#000"
                        }
                    }
                }]
            }
        ]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//首页超期还款
export const homeChaoQi = (p) => {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        title: {
            text: p.type == 1 ? '超期设备(台)' : '超期客户(家)',
            subtext: String(p.data),
            textStyle: {
                color: '#fff',
                fontSize: 12
            },
            x: "center",
            y: "30%",
            subtextStyle: {
                x: "center",
                y: "0%",
                fontSize: 25,
                fontWeight: 'bold',
                color: '#bf0000'
            }
        },
        angleAxis: {
            max: 100 + p.data,
            clockwise: false, // 逆时针
            show: false,
            startAngle: 20,
        },
        radiusAxis: {
            type: 'category',
            show: true,
            axisLabel: {
                show: false,
            },
            axisLine: {
                show: false,

            },
            axisTick: {
                show: false
            },
        },
        polar: [{
            center: ['50%', '50%'], //中心点位置
            radius: '165%' //图形大小
        }],
        series: [{
                type: 'bar',
                z: 10,
                data: [p.data],
                coordinateSystem: 'polar',
                barWidth: 10,
                itemStyle: {
                    normal: {
                        opacity: 1,
                        color: '#bf0000',
                        shadowBlur: 5,
                        shadowColor: '#bf0000',
                    }
                },
            },
            {
                type: 'pie',
                name: '内层细圆环',
                radius: ['80%', '83%'],
                startAngle: 110,
                hoverAnimation: false,
                clockWise: true,
                itemStyle: {
                    normal: {
                        color: '#ccc',
                    }
                },
                tooltip: {
                    show: false,
                },
                label: {
                    show: false
                },
                data: [10]
            }
        ]
    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//首页近30天报修曲线折线图
export const homeBaoXiu = (p) => {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        tooltip: {
            trigger: 'axis',
        },
        grid: {
            left: '0%',
            right: '1%',
            bottom: '1%',
            top: '12%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ccc'
                }
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: true,
                color: 'white',
            },
            data: p.date.reverse(),
        },
        yAxis: {
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dashd',
                    color: '#ccc',
                    opacity: .6
                }
            },
            type: 'value',
            minInterval: 1,
            show: true,
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: true,
                color: 'white',
                interval: 0
            },
            axisLine: {
                lineStyle: {
                    color: '#ccc'
                }
            },
            data: []
        },
        series: [{
            label: {
                show: false,
                position: ['4%', '20%'],
                color: 'white'
            },
            name: '报修',
            type: 'line',
            itemStyle: {
                opacity: 0.9,
                color: '#EDB941'
            },
            data: p.data.reverse()
        }, ]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//首页中国地图
export const homeChinaMap = (p) => {
    var myChart = echarts.init(document.querySelector('.main-center'));
    myChart.clear()
    var mapName = 'china';
    var chinaGeoCoordMap = {
        '黑龙江': [127.9688, 47.3688],
        '内蒙古': [110.3467, 41.4899],
        "吉林": [125.8154, 44.2584],
        '北京市': [116.4551, 40.2539],
        "辽宁": [123.1238, 42.1216],
        "河北": [114.4995, 38.1006],
        "天津": [117.4219, 39.4189],
        "山西": [112.3352, 37.9413],
        "陕西": [109.1162, 34.2004],
        "甘肃": [103.5901, 36.3043],
        "宁夏": [106.3586, 38.1775],
        "青海": [101.4038, 36.8207],
        "新疆": [87.9236, 43.5883],
        "西藏": [91.11, 29.97],
        "四川": [103.9526, 30.7617],
        "重庆": [108.384366, 30.439702],
        "山东": [117.1582, 36.8701],
        "河南": [113.4668, 34.6234],
        "江苏": [118.8062, 31.9208],
        "安徽": [117.29, 32.0581],
        "湖北": [114.3896, 30.6628],
        "浙江": [119.5313, 29.8773],
        "福建": [119.4543, 25.9222],
        "江西": [116.0046, 28.6633],
        "湖南": [113.0823, 28.2568],
        "贵州": [106.6992, 26.7682],
        "云南": [102.9199, 25.4663],
        "广东": [113.12244, 23.009505],
        "广西": [108.479, 23.1152],
        "海南": [110.3893, 19.8516],
        '上海': [121.4648, 31.2891],
        "成都": [102.9526, 30.7617],
    };
    if (p.type == 1) { chinaGeoCoordMap = p.addressObj }
    /*获取地图数据*/
    myChart.showLoading();
    var mapFeatures = echarts.getMap(mapName).geoJson.features;
    myChart.hideLoading();

    mapFeatures.forEach(function(v) {
        // 地区名称
        var name = v.properties.name;
        // 地区经纬度
        chinaGeoCoordMap[name] = v.properties.cp;
    });
    var chinaDatas = [
        [{
            name: '黑龙江',
            value: 100
        }],
        [{
            name: '内蒙古',
            value: 0
        }],
        [{
            name: '吉林',
            value: 0
        }],
        [{
            name: '成都',
            value: 10
        }]
    ];
    if (p.type == 1) { chinaDatas = p.addressArr }
    var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            var dataItem = data[i];
            var fromCoord = chinaGeoCoordMap[dataItem[0].name];
            var toCoord = p.root;
            if (fromCoord && toCoord) {
                res.push([{
                    coord: toCoord,
                }, {
                    coord: fromCoord,
                    value: dataItem[0].value
                }]);
            }
        }
        return res;
    };
    var series = [];
    [
        //['广西', p.type == 1 ? chinaDatas : []]
        ['广西', []]
    ].forEach(function(item, i) {
        series.push({
            type: 'lines',
            tooltip: {
                show: false
            },
            zlevel: 2,
            effect: {
                show: true,
                period: 4, //箭头指向速度，值越小速度越快
                trailLength: 0.7, //特效尾迹长度[0,1]值越大，尾迹越长重
                symbol: 'arrow', //箭头图标
                symbolSize: 7, //图标大小
            },
            lineStyle: {
                normal: {
                    width: 0.1, //尾迹线条宽度
                    opacity: 0.2, //尾迹线条透明度
                    curveness: .3, //尾迹线条曲直度
                    color: '#fff'
                }
            },
            data: convertData(item[1])
        }, {
            type: 'scatter',
            coordinateSystem: 'geo',
            z: 100,
            rippleEffect: { //涟漪特效
                period: 4, //动画时间，值越小速度越快
                brushType: 'fill', //波纹绘制方式 stroke, fill
                scale: 7 //波纹圆环最大限制，值越大波纹越大
            },
            label: {
                normal: {
                    show: false,
                    position: 'right', //显示位置
                    offset: [0, 0], //偏移设置
                    formatter: function(params) { //圆环显示文字
                        return params.data.name;
                    },
                    fontSize: 13
                },
                emphasis: {
                    show: false
                },
            },
            symbol: function(e, v) {
                if (p.type == 1) {
                    if (v.data.type == 1) return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeCAYAAADU8sWcAAAFEklEQVRIS7WWa4iUVRjH///zzu6apu7uuGZa4AWlUiSz2A3MZrzsuNKmpiRB+UkMxCCpwIRI+1AEkrJhISalqJmZRZE7s+rOu166WF4wqQRRSUpaZ8Zbu+7uzHv+8aozrbo7u232fnnhPM9zfs/lPM85RJ4vFQtvAjAaRotKp7r78un2RMbOjBLR0CJDLhYwHNAZQu8KOBKMNOzsCagjmw7hiejEeYbmkMC1gs4RnEzoPQDrZVlpHJwonhr/ioT+iyO3wBPR8AxjkCitjO9PxsLfAopCPAZiK6AFwYi77sLuSSO8tK2Gwz+OBrQ9HHYzPXHiBvj5naFQOmN7D6zas8PfLAsPRtzlqbrwUgive1aRsirX9eXNuycNac5oNmTPB23vrZxe2/pvnMjBz0UnPeTQjiqNuFuyG7SH+2upaHiDiOkBqaL/NPdEVu/sjsfKCozztBVarCncMihS19QdJ3gx+mhpWoUjQM5ICx/4RoN0x1k/ipvh2lFVlHJadkMYYIpUURJ2L7SHpHZO6S/rzaVkWIQtN8tvdoiJWPgygTtvEEh+W30G8EVQv0CIZeU0LJP0KsG9kj7vKEIZ9obVHIJxv1OsWFtWFT9+CzwZDX1Iw6GS31JoJPEXhDpJh0GuBHAfgIsArrQz7gugDwQP0EswXABhF6Rakc8SeBAWNTS6BGKphCY4WB6c4kbbO8BkLPwngIE3LALvl0biC6+lHRUGmlUScb/I6iRioSUE3wJ8R/WahAvGsY0WgYmO1cee0ThY3EWiF6x+7uVk9regcKUR9pdE4jW5LCZj4a8JDBZwN4ALBK5IWh+c5q7KwmXtUwOqGnIpTsVCS3QNXi+o3lgk4KAJ4GDP2h9IZwxg+xnLNhg0sVmbi2e6F1N1oTcAlJ06ffmFh58/mPZrfozEEAi9AKVBehQaBB2GOB/EPaTSEr2cx0BAQADQdxK+N+RzVthH6hDBMIjRENZKSAtaYIiPBLRct58JMhmsjE9hIho6RNKPOvdJ2kaLTXC4FsCYTttG+gQWqzo+dBhPi4MZx5gC2bGyOJLVMwG0lFS6Rzqd7f8MGVR03rNaFYy4izuSp3ZNHmtaWs8wEAimC8yVAZPrf7/ltOcbBtmad6Djl8ABOodrzfiC88P7lhMIlEy9NhFvA1yXIRwD6IH6sbPIfZA/rv3/bYBLAA8QaPX6tD1hmgr9i+bXfPCr17KBSivd1T2LnEhaTysMzTBQ6xTIVAyYvPdAMhauzQdXPNQr1com+N62Xeo7uPpgcw/Srigc1cHj2wJfIVCTSaefCRQUrO4q8mQstJ2gKY3EZ/YocgqNogYWtKG6X7WbOLdrwihjAxthWQSqPm/aY+FyQvcGI+62nsGhEYSd48E05jYwfABWGwmsyQdXPBRY3uDaZctgewQHVE5yI6DcHS1xHIDyfK2Wr4XbTcrO1a73eZuk1gxTswZFjjYlah9/hA5rIBpA3+SLvCsHujHhFBV1lDLzSbwpaUUh2ma0oWh9VwfutsCvvuFioSUAlxl49xdH9pzqqtW6AvvybkUOx/kU1q4D9YksJgVPX56dGtrvy/89cgInRY0k03NKp+7/LRENzyPwJIBiUD/dlpr7j7+MMsPap8sRNgAcLuvNs445mZUFLOeLWkhwc4ZakVv3PJvU2eMjp5/o1hM6l/ZULHxKwNDu1CqvjrA1OC0+tzv75ODJaGgvyAndMcpzvwvEO8FK9+Xu7PM3GTygPc4bQeUAAAAASUVORK5CYII='
                    if (v.data.type == 2) return 'image://data:image/png;base64,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'
                }
                if (p.type == 2) {
                    return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAfCAYAAAASsGZ+AAABLklEQVRIS+3VvyvFURjH8df5yo8MkiIDA/4Edn1vKYtV+U8wGQz+D8qoDMpCWclglIUUIhaJcI+u2yU3fa9jMOh71ufT837Op+d8TvAHJ+yyHDmssIGYwtxmpJ2ZjPHIGAbRh65AZ+QiZ6gGeW8cOY6strP1ylHOSzNwiWySUUxG5gIVhKLBcsIHpEn4GDkN3OC5NllkIGMo0pFy2yJISp9CbQlJsrK0q7QryYEk8f/YrshVhcH3gIw8BLqTfKiLbyJbkQOcVLnMuI3UAvbxjvtZXhuQxSr7WT2+pzBcALyO7GG9h82JekoXnkbUL+SsNJR79L/U/43eWsxXeWjj+omzaW5bNW2ufwtJbdJKX0JaOfSlXtpV2vX54pO8+IH4b7Zrh/PAfM7aD4b6leQNpnyGIMrsjl4AAAAASUVORK5CYII='
                }
                if (p.type == 3) {
                    return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAeCAYAAADHJYVoAAADyElEQVRIS52VW4gbZRTH/+fL7HbdZLItGwRRqqJgoYtt13ZbL636Ivigb0WoVqgPFdzJ5rJFUdl22kVF6SaTZFbQBwWLRembPgi+qK23dtdeZAstbVGLF5CUbmaSut1NviMz24m5TNLEPIXvf87v/OfMmfMR2vzGD1oR7qMdDH4SLNaB+FY3nOlvkDxDoC9ogQ9P7Qnn/TDkd6h/yH1XS/aEgIgBHGxnAKCShMysCqqT+i5aqI1tgsfTV++ConxOhCEf6JUbZ4ONGjPmUC4/ZSRW/eppdfBo9todAap8R4TVtckMXGLghYymHnXOY6a9jYAPCLinLo5xucKBh3Nj/b8751W4rrMyHyl9T+BN9WC6pnBg6GD0ll9qz/fk/rm7TJU5Avc3xM+szAcf0nUqV+Fxs5gk8FRzK/hQWgs/79f3hGl9BNDOphaBxg0tlHLhu/U/+4MR9TcAkcZAYuxPRVXdD57M2ToT9vlo+VLevtOFx3KF5wSJQy2m4nBaU5/1d25/DGCHnyZZ7nTh8Zz9CRGe8YfTghRyfeal8PlaPfaudZ+Q4jTAfX55zPjUhSdM+wKAe1vNMzNfQjmw1UgE/3LNpEu3QakcI6K6aWnIv+jBneFf4QOvAGwsAm9Na2Fvxt2wUdMa7AVeBSgOIOCTe92Dc7NIi5Ll9kw0/FmrJ1p+X9bTgsQRgHubhuFGW+YBDNTPq0wY2oDRDuxpcbMQJ4h0Q2xh2XnOmgHRxqrIfG7girpW10l2Atd1FoVB+yyI1tQwZpenJWtNkaCkJzDTK0Y09E4n4Kr7XPFlIn67ypC8/BHFjMJmoYgfPUEQb50aDX/bDXx82npEMh3zcmRZbqn5/O1vCNjmiCTFcGoseKobeDJb2sBCnnRyGDhqaOqjVbgrkjwBggJGGUTlbuBgVrxcYjHimKtbucmcfYAJE11BG4KJMZmKqnvdDtRq2/WzvbdHVs8QcP//KcDAz3/kL286oq9dbIK7k2PODxMCzsvt6bLAEqOyxdBWun33hbsFpu19xPBds60KMkE3RtX9tbrvBb37Pe4JLhVPAFjfofvTpZ7QyPsv0tJN4U5AMltcx8TO9DTtjLqCjEViGkmNhc40GvF1/t9XZ08Q4UA798zYa0TVSb+YtnDn0i5EiscBDLcocHIgH9rsXMZdw52EsYw9FAhg1mffX69UsDEbU+daPVlb515SwrReA+iNegi/ntbCb7ZrWUfwx/SvlA2RB34AvLXMs6fyPz34tf542xXREdxxp+WsNT1EXzr/l5ifMKPhczcb038BKjRo/LEOXX8AAAAASUVORK5CYII='
                }
            },
            animation: true,
            symbolSize: [23, 26],
            itemStyle: {
                normal: {
                    show: true,
                    color: '#7194F3'
                },
                emphasis: {
                    scale: false
                }
            },
            data: p.data,
        }, {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 200,
            rippleEffect: { //涟漪特效
                period: 4, //动画时间，值越小速度越快
                brushType: 'stroke', //波纹绘制方式 stroke, fill
                scale: 5 //波纹圆环最大限制，值越大波纹越大
            },
            symbolOffset: [0, 0],
            symbol: 'circle',
            symbolSize: 15,
            itemStyle: { color: '#bf0000', },
            data: p.type == 1 ? [{ name: '', value: p.root }] : [],
        });
    });
    var option = {
        tooltip: {
            trigger: 'item',
            enterable: true,
            position: 'right',
            formatter: function(params) {
                if (p.type == 1) {
                    if (params.data.factorNo == undefined && params.data.modelName == undefined) return ''
                    return `<div style='padding:10px;line-height:26px'>
                        <p>设备类型：${params.data.type==1?'塔机':'升降机'}</p>
                        <p>出厂编号：${params.data.factorNo}</p>
                        <p>规格型号：${params.data.modelName}</p>
                        <p style="display:${(params.data.type==1 && params.data.imei)?'block':'none'}">
                            监控主机：
                            <span 
                                onclick="toDevice(\'` + params.data.imei + `\',\' ` + params.data.type + `\', cagecate=2)"
                                style="pointer-events:auto;background:#edb941;padding:1px 3px;cursor:pointer;border-radius:5px"
                            >
                                ${params.data.imei}
                            </span>
                        </p>
                        <p style="display:${(params.data.type==2 && params.data.imei)?'block':'none'}">
                        左笼监控：
                        <span 
                            onclick="toDevice(\'` + params.data.imei + `\',\' ` + params.data.type + `\', cagecate=1)"
                            style="pointer-events:auto;background:#edb941;padding:1px 3px;cursor:pointer;border-radius:5px"
                        >
                            ${params.data.imei}
                        </span>
                        </p>
                        <p style="display:${(params.data.type==2 &&params.data.rightImei)?'block':'none'}">
                        右笼监控：
                        <span 
                            onclick="toDevice(\'` + params.data.rightImei + `\',\' ` + params.data.type + `\', cagecate=2)"
                            style="pointer-events:auto;background:#edb941;padding:1px 3px;cursor:pointer;border-radius:5px"
                        >
                            ${params.data.rightImei}
                        </span>
                        </p>
                        <p>购买方：${params.data.customerName || ''}</p>
                    </div>`
                }
                if (p.type == 2) {
                    return `<div style='padding:10px;line-height:26px'>
                        <p>客户：${params.data.name}</p>
                        <p>地址：${params.data.address}</p>
                        <p>人员：${params.data.linker}</p>
                        <p>电话：${params.data.linkerTel}</p>
                    </div>`
                }
                if (p.type == 3) {
                    return `<div style='padding:10px;line-height:26px'>
                        <p>网点：${params.data.name}</p>
                        <p>地址：${params.data.address}</p>
                        <p>人员：${params.data.linker}</p>
                        <p>电话：${params.data.linkerTel}</p>
                    </div>`
                }
            }
        },
        color: ['#7194F3'],
        geo: {
            //aspectScale: 0.8,
            silent: false,
            map: mapName,
            zoom: 1.24,
            //top: '10%',
            //bottom: '10%',
            animation: false,
            label: {
                normal: {
                    show: false,
                    textStyle: {
                        color: '#fff'
                    }
                },
                emphasis: {
                    textStyle: {
                        color: '#fff'
                    }
                }
            },

            roam: false,
            itemStyle: {
                normal: {
                    areaColor: 'rgba(0,255,255,0)',
                    borderColor: '#EDB941',
                    borderWidth: 1.5,
                    shadowColor: 'rgba(0,255,255,0)',
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 10,
                },
                emphasis: { // 也是选中样式
                    borderWidth: 2,
                    borderColor: '#EDB941',
                    areaColor: 'rgba(0, 255, 255, 0.1)',
                    label: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                }
            }

        },
        series: series
    }
    const _this = p._this
    window.toDevice = function(imei, type, cagecate) {
        if (type == 1) {
            _this.$router.push('/TowerBigScreen?imei=' + imei)
        } else {
            _this.$router.push('/LifterBigScreen?imei=' + imei + '&cagecate=' + cagecate)
        }

    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);

    })

};

//生产页面近12月产量折线图
export const shengchanLine = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        tooltip: {
            trigger: 'axis',
        },
        grid: {
            top: '30%',
            left: '0%',
            right: '2%',
            bottom: '0%',
            containLabel: true
        },
        title: {
            text: '近12个月的产量曲线',
            textStyle: {
                fontSize: 15,
                color: '#fff',
                lineHeight: 20,
                itemGap: 100
            },
        },
        xAxis: [{
            type: 'category',
            minInterval: 5,
            axisLine: {
                show: true,
                color: '#fff',
                lineStyle: {
                    color: '#fff',
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: '#fff',
                width: 100,
            },
            splitLine: {
                show: false
            },
            boundaryGap: false,
            data: p.date.reverse()
        }],

        yAxis: [{
            type: 'value',
            minInterval: 1,
            show: true,
            splitNumber: 4,
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dashed',
                    color: '#fff',
                    opacity: .5
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#fff',
                }
            },
            axisLabel: {
                show: true,
                margin: 5,
                textStyle: {
                    color: '#fff',

                },
            },
            axisTick: {
                show: false,
            },
        }],
        series: [{
            name: '产量',
            type: 'line',
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: 2,
            lineStyle: {
                normal: {
                    color: "#EDB941",
                    width: 1.5
                },
            },
            label: {
                show: true,
                position: 'top',
                textStyle: {
                    color: '#EDB941',
                }
            },
            itemStyle: {
                color: "#fff",
                borderColor: "#7194F3",
                borderWidth: 2,
            },
            areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#EDB941'
                        },
                        {
                            offset: 1,
                            color: 'rgba(225, 176, 63, 0)'
                        }
                    ], false),
                }
            },
            data: p.data.reverse()
        }, ]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//生产页面规格型号饼图
export const shengchanPie = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var colorList = ['#7194F3', '#AD454E', '#EDB941', '#FDB36A', '#6D9E7B', '#BC857E', '#58D5FF'];
    for (let i = 0; i < 5; i++) {
        colorList = [...colorList, ...['#7194F3', '#AD454E', '#EDB941', '#FDB36A', '#6D9E7B', '#BC857E', '#58D5FF']]
    }
    var option = {
        tooltip: {
            trigger: 'item',
            formatter: function(params) {
                return params.data.name + ':' + params.data.value + '%'
            }
        },
        series: [{
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['45%', '80%'],
            clockwise: true,
            avoidLabelOverlap: true,
            hoverOffset: 15,
            itemStyle: {
                normal: {
                    color: function(params) {
                        return colorList[params.dataIndex]
                    },
                }
            },
            label: {
                show: true,
                position: 'inside',
                fontSize: 12,
                formatter: function(params) { return params.data.value + '%' },
                align: 'center',
            },
            data: p.data,
        }]
    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//生产也年度发货排行柱图
export const shengchanBar = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));

    var option = {
        tooltip: {
            trigger: 'item',
            axisPointer: {
                type: 'shadow',
                lineStyle: {
                    color: '#23d2cc',
                    width: 0,
                    type: 'solid'
                },
            },
            textStyle: {
                textBorderWidth: 10
            }
        },
        grid: {
            left: '4%',
            right: '3%',
            bottom: '1%',
            top: '4%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            minInterval: 1,
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ccc'
                }
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: true,
                color: 'white',
                fontSize: 10,
            },
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dashd',
                    color: '#ccc',
                    opacity: .6
                }
            },
            max: p.max
        },
        yAxis: {
            type: 'category',
            show: true,
            axisTick: {
                show: false,
            },
            axisLine: {
                lineStyle: {
                    color: '#ccc'
                }
            },
            axisLabel: {
                show: true,
                color: 'white',
                fontSize: 10,
            },
            data: []
        },
        series: [{
            label: {
                show: true,
                position: ['40%', '15%'],
                color: 'white',
                formatter: function(p) {
                    return p.name + ':' + p.value
                }
            },
            name: [],
            stack: '排行',
            type: 'bar',
            barWidth: 15,
            barCategoryGap: 15,
            itemStyle: {
                opacity: 0.9,
                color: '#7194F3',
                // color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                //     offset: 0,
                //     color: "yellow" // 0% 处的颜色
                // }, {
                //     offset: 1,
                //     color: "red" // 100% 处的颜色
                // }], false)
            },
            data: p.data.reverse()
        }]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//生产页超期服役统计
export const shengfuyiBar = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    let color = ['#6D9E7B', '#EDB941', '#AD454E', '#009DFF'];
    let chartData = [{
            name: "正常",
            value: p.normal,
            unit: '台',
        },
        {
            name: "一年内到期",
            value: p.aYearOverdue,
            unit: '台'
        },
        {
            name: "已超期",
            value: p.overdue,
            unit: '台'
        },
    ];
    let arrName = [];
    let arrValue = [];
    let sum = 0;
    let pieSeries = [],
        lineYAxis = [];

    // 数据处理
    chartData.forEach((v, i) => {
        arrName.push(v.name);
        arrValue.push(v.value);
        sum = sum + v.value;
    })

    // 图表option整理
    chartData.forEach((v, i) => {
        pieSeries.push({
            name: '学历',
            type: 'pie',
            clockWise: false,
            hoverAnimation: false,
            radius: [63 - i * 15 + '%', 73 - i * 15 + '%'],
            center: ["45%", "50%"],
            label: {
                show: false
            },
            data: [{
                value: v.value,
                name: v.name
            }, {
                value: sum - v.value,
                name: '',
                itemStyle: {
                    color: "rgba(0,0,0,0)"
                }
            }]
        });
        pieSeries.push({
            name: '',
            type: 'pie',
            silent: true,
            z: 0,
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [63 - i * 15 + '%', 73 - i * 15 + '%'],
            center: ["45%", "50%"],
            label: {
                show: false
            },
            data: [{
                value: 7.5,
                itemStyle: {
                    color: "#E3F0FF"
                }
            }, {
                value: 2.5,
                name: '',
                itemStyle: {
                    color: "rgba(0,0,0,0)"
                }
            }]
        });
        v.percent = (v.value / sum * 100).toFixed(1) + "%";
        lineYAxis.push({
            value: i,
            textStyle: {
                rich: {
                    circle: {
                        color: color[i],
                        padding: [0, 5],
                    }
                }
            }
        });
    })

    var option = {
        title: {
            text: `
            超
            期   
            服
            役
            统
            计`,
            left: '-57',
            top: 'center',
            right: '100%',
            textStyle: {
                color: '#EDB941',
                fontSize: 16,
                lineHeight: 20
            }
        },
        color: color,
        grid: {
            top: '15%',
            bottom: '54%',
            left: "40%",
            containLabel: false
        },
        yAxis: [{
            type: 'category',
            inverse: true,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                formatter: function(params) {
                    let item = chartData[params];
                    return '{line|}{circle|●}{name|' + item.name + ' ' + '}{value|' + item.value + ' ' + '}台'
                },
                interval: 0,
                inside: true,
                textStyle: {
                    color: color,
                    fontSize: 12,
                    // rich: {
                    //     line: {
                    //         width: 170,
                    //         height: 10,
                    //         //backgroundColor: '#fff'
                    //     },
                    //     name: {
                    //         color: '#666',
                    //         fontSize: 14,
                    //     },
                    //     bd: {
                    //         color: '#ccc',
                    //         padding: [0, 5],
                    //         fontSize: 14,
                    //     },
                    //     percent: {
                    //         color: '#333',
                    //         fontSize: 14,
                    //     },
                    //     value: {
                    //         color: '#333',
                    //         fontSize: 16,
                    //         fontWeight: 500,
                    //         padding: [0, 0, 0, 20]
                    //     },
                    //     unit: {
                    //         fontSize: 14
                    //     }
                    // }
                },
                show: false
            },
            data: lineYAxis
        }],
        xAxis: [{
            show: false
        }],
        series: pieSeries
    };
    myChart.setOption(option);

    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//生产页中国地图
export const shengchanMap = (p) => {
    var myChart = echarts.init(document.querySelector(p.doc));
    var mapName = 'china'
    var chinaGeoCoordMap = {
        '黑龙江': [127.9688, 47.3688],
        '内蒙古': [110.3467, 41.4899],
        "吉林": [125.8154, 44.2584],
        '北京市': [116.4551, 40.2539],
        "辽宁": [123.1238, 42.1216],
        "河北": [114.4995, 38.1006],
        "天津": [117.4219, 39.4189],
        "山西": [112.3352, 37.9413],
        "陕西": [109.1162, 34.2004],
        "甘肃": [103.5901, 36.3043],
        "宁夏": [106.3586, 38.1775],
        "青海": [101.4038, 36.8207],
        "新疆": [87.9236, 43.5883],
        "西藏": [91.11, 29.97],
        "四川": [103.9526, 30.7617],
        "重庆": [108.384366, 30.439702],
        "山东": [117.1582, 36.8701],
        "河南": [113.4668, 34.6234],
        "江苏": [118.8062, 31.9208],
        "安徽": [117.29, 32.0581],
        "湖北": [114.3896, 30.6628],
        "浙江": [119.5313, 29.8773],
        "福建": [119.4543, 25.9222],
        "江西": [116.0046, 28.6633],
        "湖南": [113.0823, 28.2568],
        "贵州": [106.6992, 26.7682],
        "云南": [102.9199, 25.4663],
        "广东": [113.12244, 23.009505],
        "广西": [108.479, 23.1152],
        "海南": [110.3893, 19.8516],
        '上海': [121.4648, 31.2891],
        "成都": [102.9526, 30.7617],
    };
    /*获取地图数据*/
    myChart.showLoading();
    var mapFeatures = echarts.getMap(mapName).geoJson.features;
    myChart.hideLoading();

    mapFeatures.forEach(function(v) {
        // 地区名称
        var name = v.properties.name;
        // 地区经纬度
        chinaGeoCoordMap[name] = v.properties.cp;
    });

    var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            var dataItem = data[i];
            var fromCoord = chinaGeoCoordMap[dataItem[0].name];
            var toCoord = [104.4648, 31.2891];
            if (fromCoord && toCoord) {
                res.push([{
                    coord: toCoord,
                }, {
                    coord: fromCoord,
                    value: dataItem[0].value
                }]);
            }
        }
        return res;
    };
    var option = {
        tooltip: {
            trigger: 'item',
            formatter: function(params) {
                var anjie = '';
                if (params.data.loanState == 0) {
                    anjie = '未还款'
                }
                if (params.data.loanState == 1) {
                    anjie = '已超期'
                }
                if (params.data.loanState == 2) {
                    anjie = '超期还款'
                }
                if (params.data.loanState == 3) {
                    anjie = '已还款'
                }
                return `<div style='padding:10px;line-height:26px'>
                    <p>设备类型：${params.data.type==1?'塔机':'升降机'}</p>
                    <p>出厂编号：${params.data.factorNo}</p>
                    <p style="display:${params.data.type==1?'block':'none'}">监控主机：${params.data.imei}</p>
                    <p style="display:${params.data.type==2?'block':'none'}">左笼监控：${params.data.imei || ''}</p>
                    <p style="display:${params.data.type==2?'block':'none'}">右笼监控：${params.data.rightImei || ''}</p>
                    <p>在线状态：${params.data.onlineState==0?'未通电':(params.data.onlineState==1?'在线':'信号差')}</p>
                    <p>锁机状态：${params.data.lockState==0?'未锁机':'已锁机'}</p>
                    <p>按揭状态：${anjie}</p>
                </div>`
            }
        },
        color: ['#7194F3'],
        geo: {
            //aspectScale: 0.50,
            silent: false,
            map: mapName,
            zoom: 1.24,
            //top: '10%',
            //bottom: '10%',
            animation: true,
            label: {
                normal: {
                    show: false,
                    textStyle: {
                        color: '#fff'
                    }
                },
                emphasis: {
                    textStyle: {
                        color: '#fff'
                    }
                }
            },

            roam: false,
            itemStyle: {
                normal: {
                    areaColor: 'rgba(0,255,255,0)',
                    borderColor: '#fff',
                    borderWidth: 1.5,
                    shadowColor: 'rgba(0,255,255,0)',
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 10,
                },
                emphasis: { // 也是选中样式
                    borderWidth: 2,
                    borderColor: '#fff',
                    areaColor: 'rgba(0, 255, 255, 0.1)',
                    label: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                }
            }

        },
        series: [{
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            symbol: function(e, p) {
                if (p.data.type == 1) {
                    if (p.data.loanState == 1 || p.data.lockState == 1) return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAERUlEQVRIS63WeYzdUxTA8c99r4widokgVKyxhRD8Ue28145Ki1pSS7WJhsYSoUSCtFESsUeENEUkJEiltIk1KPObJhS1U2pJBI1KU4RKTen8flduf28Yr6/zzHD/vPee8z3n3LPcoM3qYUpkSY2f290dynkY7HI38wLTkWPeHzw2gc+GAtjS3ZbgF+gYyRORm7E4sHtkeoVDsV/OQ+NY9l8M2Az8Irtsw8OBa8byZTffRWZUWNTHYduxdgMzArXIw3VeGI4B/wBnjMI9VWaOYW1SmLEqZ9IIzimYUOfYtB8JPZyt3H9yR546lo3/1oi/wBmHYy6m19jQryDj25xTxvNRxtt4tcZ1AwE9dOGinNc6eGQ0v7YzIGRMCxwamRq4veHNxl4WTmRdxtd9nNrFxxl7R1Zgcp2lzcq7OSZwCb7u5cGJjai1MiKBkxebwjdwpfcLfIWrA/dFvm8YdVyFSZEbBtwPkZ0jP1cJBbsGzotkkQ+qjAjkG3h8AuuTXHqnedgnkqfDSJH2Kywu+C0wL7LnIKF7A30VHimYGVgV+QXH4w5cE1mDHwNH5owbz5rk8Rc4sFlxTr3KysCyyH6D1OMVRan0UuVTTYisrfB95KTIysqmXLR9zqIKt+VckMALIjvghMAuAwDPKsNyShIaxOPXlNmcEnVf/BCIKeuV0TsY36CKkYH1Bb8m8Grs0RD8S/9W7DWa1T18HjloC+DeGtv2n/UwPbBiLO8P2Hu8k/Ob5cNCtt6ebbZmq5FU1zOig+pYVjXq+Esc0AocWVBnav/ZUo4uOK7GAw3ZUYEpndy5GbhdvQ3i8e99HNTFtwNqfgTm15iZ9tKASQla5/khg7v5PLQO9aU17m9W2MPTnUxueDynl3tTPxgyOGMlDmkSTGU3qc5LzQoz5vRxXxe/ZDxT47RWUR10LDbC9Uksp1LK3ldTnQduxMQaLzYr7WZyhW0Db+bMqnPlsMAZKwoeqJal8GzkusheuKsVOONWjV4eWF3hqP6BM9CAth5nfFxwZaVsIud2clIPyyNzthDq1MsPa0BizgHjy9b7j9UW3M2HFS6PXIVlgTUFF+LWVuBuLkttNlEin9b/NmJo4KxsBr8nbztY9wfTCm6oMnUsL7dIrp0iHwb2DFzbyd3DfeP3lPP5rch2qeXh4oLTx7UANzxNw2dplevH8PqwwN28G/i0YH76Z/VwU+TCwIxOljQrXcoRkZNzVqSfTCdnDguc8U7K0siswHMV1hXMypk9vgU4teDdWFJhVM6UcSwfLvjtyNxYdrBFdY5KTSXnilbgdi24/7xtVmcsD8zG5QW3BM6IdKXEqfHKvwUNuZwy3kxzteC8Dn7ayFmx/OhP/t/Ar5R/pTMq9A6wcHZk/0AIVGM59DtwUyhndfpdpKn/Y6tk21JEmv/Vj2LacMOHWm3TNGy/msGjIye2F9v8RqDoZX6rEdhK35/5EGuOAgHdxwAAAABJRU5ErkJggg=='
                    if (p.data.onlineState == 1) return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAFeElEQVRIS62Wf4xUVxXHv9/7huVnmxZCYqBpaaRottpghHlLYpmHpq2BnZldDbQgNCVIKoYAGpJiIMUmprVqGmNDsMaEJtpgUKDzBgktbXZml0XeDFt+dAXXJg1ChBAE+SHsj5l3v82bdS3sDvvL3j/fu+d8zv2ee849xBArkYkvpu05mGs8fnWovSP5z8E2J3x3G4AVkEIS28Dw97lk299GArjb3qrgmftnjn2gPPkPNPyJtdoDcKoFVhihFgYPK7S/bW4oHv5/AhgAnndg3uSakt0hYGNzMvgo4bv/VIiVxmB3ieVHbVfNpZpxdiWkBTLc0ZwM9o8mgDvA3t66GXD0yzDWs7pl4bFLkUMv654LLRYZ6mmCT+VSwZwKSOD8fXOX0PJpEH/8z4XwT23Pt5WGG8T/wN6+OV9C6GzFlYsrcivPdPU5SPjxs1asb0kHJz0/XgTwfi5V2HQ7IJFxnwD1XQCHyhrzZmu69cZQAdDLuMtlUEtgmax9NTIgWeqMcVewMLju+e4Za8vJ5oa2D7397gMoqZ1UuilVzPd3vmCv+1U5+p4Fzqir9JuWJb2qVVv0MvEiyF75blsCdlD2Y9H8EMDrlC5UFCbjABYJetH07Rco8H7AXgUNIUwBsRRAE2SPA4iBJvz31c63Tj578mblcL0lowcJhgJCSJYkLbXHALckbiMw7W6RC/oLybK1eNMQq0Wdo3BNokvYn4HcKPAipMskH+sUvhGkg4sR+O8EHhlwYuHr7LanNc4cJvDwIOB1srhsDNcAehXEUxIvgfYCrXmSBqetrCBOkrSbND8NHfscExl3J4h7QdRRmPypesqSvAmhHsCkQS7LIQklMpJbDwH4F0hRIkAL6AsA/gHAATBe4E0KN6IcnxfxOYJ3lFZJPdNb08fOJzJuB4lZdwF35lLBhE8rwF0hhe3N6aPHbquKt/Kpwnf627N2V23NPZPuGacujYlN7HLY5cQcxZzmhuK5Sh377kcAZla9mcDOplSwrO/f/MycrxiaeC5VeKNiu7duhmJ2cT5Z+PkA8FD1lsi6HVS1E6u7hHBWa6rtbJ8Pr8mL4cat7blUYXX0LXpgLHCrJV3488jBmXgHyYFSU2tyycKv+ztMZN1MPhmkKyfO1m3pdPSrqB+MGOz57mkAX+xnGIZWi1oaCu/0d+hl6rbc6C693rak7VrCj/v5VCF1lzQNLnbCd/9KoDZqh5Del2hh9GNKC3Pp4oH+1o/7btpAEwQcIbghnwrWjwrs+W67oDdAjFfJZOnYTSSmQ/pFNbDnu68AqPRyAedtrGd234NzewCDDgK9tzr+oQXWm6iJkM/k6oMnvWy8QIMtTfVVpPbj7QAf7QVLodHMQ/XFj0ec44TvnoDRWob4AcjDAi4SWkWLV5qq5Djhu98nEE0ukHAqnw4qQYwY7GXdYxC6EXY/0z1+/PWanvJyyrxoDZY1J4N3B1yuvbPvk1NzguA0US/kk4XXRgf24x8I7CIQSJgo4CaJ50U0VAP/F0Iv6+ZDyx+1pI+0jgqc8N02AqestdujOSvhz32JMKskrMyng4P9nc5/e96X6YTfhGw7aFbnk4VvjQrs+e5RWLsJNBsA7bMG1ylsgLi5GjhqwVPHTjoIYoYN7eKWxqOF0YKL1mJrrKbcYcvO7lyqMDtqKhLWVQMP1YL7/g+nnAoSN8NgrQn5soxtFPgEDV/I1R95b7igkd9q3z0iyDpOaWl3ecKVMez5tsBttErnGoqfDTi+Jz5lgkEjHHVGEVobDX5mM6DPR+OQJIdACeBYSC+J6KChKjUb4vJIpL9zrvbd3wFYPlr5EIYLco1Hc8OxvxO8x/2aHDw+HMMBOaNs53VuD5YPfAKr+fsEZMmWcP0YoHUAAAAASUVORK5CYII='
                    if (p.data.onlineState == 0) return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeCAYAAADU8sWcAAAFEklEQVRIS7WWa4iUVRjH///zzu6apu7uuGZa4AWlUiSz2A3MZrzsuNKmpiRB+UkMxCCpwIRI+1AEkrJhISalqJmZRZE7s+rOu166WF4wqQRRSUpaZ8Zbu+7uzHv+8aozrbo7u232fnnhPM9zfs/lPM85RJ4vFQtvAjAaRotKp7r78un2RMbOjBLR0CJDLhYwHNAZQu8KOBKMNOzsCagjmw7hiejEeYbmkMC1gs4RnEzoPQDrZVlpHJwonhr/ioT+iyO3wBPR8AxjkCitjO9PxsLfAopCPAZiK6AFwYi77sLuSSO8tK2Gwz+OBrQ9HHYzPXHiBvj5naFQOmN7D6zas8PfLAsPRtzlqbrwUgive1aRsirX9eXNuycNac5oNmTPB23vrZxe2/pvnMjBz0UnPeTQjiqNuFuyG7SH+2upaHiDiOkBqaL/NPdEVu/sjsfKCozztBVarCncMihS19QdJ3gx+mhpWoUjQM5ICx/4RoN0x1k/ipvh2lFVlHJadkMYYIpUURJ2L7SHpHZO6S/rzaVkWIQtN8tvdoiJWPgygTtvEEh+W30G8EVQv0CIZeU0LJP0KsG9kj7vKEIZ9obVHIJxv1OsWFtWFT9+CzwZDX1Iw6GS31JoJPEXhDpJh0GuBHAfgIsArrQz7gugDwQP0EswXABhF6Rakc8SeBAWNTS6BGKphCY4WB6c4kbbO8BkLPwngIE3LALvl0biC6+lHRUGmlUScb/I6iRioSUE3wJ8R/WahAvGsY0WgYmO1cee0ThY3EWiF6x+7uVk9regcKUR9pdE4jW5LCZj4a8JDBZwN4ALBK5IWh+c5q7KwmXtUwOqGnIpTsVCS3QNXi+o3lgk4KAJ4GDP2h9IZwxg+xnLNhg0sVmbi2e6F1N1oTcAlJ06ffmFh58/mPZrfozEEAi9AKVBehQaBB2GOB/EPaTSEr2cx0BAQADQdxK+N+RzVthH6hDBMIjRENZKSAtaYIiPBLRct58JMhmsjE9hIho6RNKPOvdJ2kaLTXC4FsCYTttG+gQWqzo+dBhPi4MZx5gC2bGyOJLVMwG0lFS6Rzqd7f8MGVR03rNaFYy4izuSp3ZNHmtaWs8wEAimC8yVAZPrf7/ltOcbBtmad6Djl8ABOodrzfiC88P7lhMIlEy9NhFvA1yXIRwD6IH6sbPIfZA/rv3/bYBLAA8QaPX6tD1hmgr9i+bXfPCr17KBSivd1T2LnEhaTysMzTBQ6xTIVAyYvPdAMhauzQdXPNQr1com+N62Xeo7uPpgcw/Srigc1cHj2wJfIVCTSaefCRQUrO4q8mQstJ2gKY3EZ/YocgqNogYWtKG6X7WbOLdrwihjAxthWQSqPm/aY+FyQvcGI+62nsGhEYSd48E05jYwfABWGwmsyQdXPBRY3uDaZctgewQHVE5yI6DcHS1xHIDyfK2Wr4XbTcrO1a73eZuk1gxTswZFjjYlah9/hA5rIBpA3+SLvCsHujHhFBV1lDLzSbwpaUUh2ma0oWh9VwfutsCvvuFioSUAlxl49xdH9pzqqtW6AvvybkUOx/kU1q4D9YksJgVPX56dGtrvy/89cgInRY0k03NKp+7/LRENzyPwJIBiUD/dlpr7j7+MMsPap8sRNgAcLuvNs445mZUFLOeLWkhwc4ZakVv3PJvU2eMjp5/o1hM6l/ZULHxKwNDu1CqvjrA1OC0+tzv75ODJaGgvyAndMcpzvwvEO8FK9+Xu7PM3GTygPc4bQeUAAAAASUVORK5CYII='
                    if (p.data.onlineState == 2) return 'image://data:image/png;base64,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'
                } else {
                    if (p.data.loanState == 1 || p.data.lockState == 1) return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAACh0lEQVRIS53VT4hVVRzA8c95zz+MaC00hUBLaUxRW4hoYIt5Q7ioFCQR2rVoFYqbFiKotWnjHxQcNyoIIYKgEkQW8+eJCmooKOFCxU2oKOaqEBude+K8+0Yfw71vuJ7NvZxzft/z+/8LCtZFFr/kBno6jyOj+Kyf4YlioQg0xEd1TmHVVFp3nuKtfG+gwS9VQH8E7kRqbaGI9/FVVdDNyOmMHdORETOOYG8lUI0zNcawpY/BpFUz/x4sBA3yNhZ02lxnQWBPje8yBp7wwWbGuoKa3EFvgdPvN5jf5GTkbj+7JgP9jdlloN+ZOy13+trAgVLTmjzBnDJQ2h9mS4118jw6XuijMlDgrz7eG3+gyW9y2IZKILwI3I3thMRMzMf6qqCkzPc4kX5SHgWOhbI8alLo7JhXRaqPLxpcSf8jeY1dqnEje61pOrodRrgXWDTR2ZF72BY4NItlq3g2wtXA6oK7z8IQ8+osHet4oc67yawGvSMcDsxo8HUz12xNQYT/61b9pxPoGlP/4VbG7sA3gf43AiWhQVbUOYexMKGc2tByjaZwNvL5+OuRjYEfi/oXupqW2sjjwCN5T8oivclfVU1Ljn2Ijxt5iqQ2chGfFERttNTZUziaMVTjwz6+bIMuJ3CBRg+6Re0MluDPyPZ+fm63keMZ58dhNcJ0nk4a/mFWpoi9zAdCKpcDlVptnVYetUtjX2B2oCfyU1XQqUZuWppB9Xe4iuXYVBV0IeZzrLUCC/FpaRspSrD2gEyN7IcOUMqjb7Gzq0a/ksZXa/WwNKVN8kdHdGLK7sjW53m3bK1/iZsZDe2ivBxZ0SEkMq2kHF5E6fiVyUnT/eOg61hcIjjZdprAA/8D+wjeA5v/4e0AAAAASUVORK5CYII='
                    if (p.data.onlineState == 1) return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAADHklEQVRIS52VS2icVRiGn/fMNGlqpJR6q9B6oakt2iwamT9oawaVgpeZUqwFdy5cScWNCxHUunHjhQpGEBUKRYSRRmeqNhBLJ1ZoZiRYKRZM6UJRUdqsLDWZZP5X/iRT0mYmYTyrw/+f7/ku53u/I5qsnV9ntqRmdUaia/Fv41osP34q98OJ683UDLSrGPWm5AJTl++f6Vy3cOYSq1hbQAyW89Wv2gFVLU3IhHkjG3Qn+Jk2QfwEHJ2d9St0QojlYH8EvN0eCA8Z1YEDo3sqI0lM2WPRCPZ7TUF9hb61N3Sw6ZqiKrUpJb0Vi5eCGbx5qrL58/3UlwVlS9EE0LOk6OL3cq6yMVuMPjOcH91TeW0l0CVgfSvQA0O9t3SkVk9IftAKh1qmli1FF4GbWoHmalPMHLDYLVQDH25ao1Yg499G89U7Gg6yxzLDtnYL59sDmRnEecFcQxp3C20E59oCzUUiHyROfZpsa3HNHanUJy37KFuKmhfbTM7DeLKcr4wl24FS5gToe+Qzjn1VXnXxiwZKmQtCdy8ptn1B8KLR+/+E2XvHc+NXBkpRRZC5/qzxFT1SjG6tB21b7EHEt6NwsJyv9AwUMx8osKacqz6bLUZjiGip0D29jPo5moD6Puxb1b0h/TP4deA5oYf/FygxeujLvu0hpI8b14WukdPCZGgdUZC/kOpPNLw7Tu+VeLPZ/ILlU0vGyN/AXzZBIjbuEVrTVmoBxiT/ier95dx40iJkS9EpYOeSW7NrLYsd5I+xvkXcM5qvPLUAOg30N0nvj9a3hof4sbqVHdFZwcsn85VithiNEOLDgXS5AYtrsabrYXLF699V6t8R8PEp09slJ3I51N6o1XwfzUmjmHlHgfU2XYIjbYJcKOerWxPQ0wVSF1dHFfB9wL42QXxnUwiNxwjuwjzacow0a7DkgQx4WOKNqw2pEBPHz0u8umxEj32zubNh9O/0um2kdNJwZCEgYmTw3hi90J2eHG6c/fVyh8/tP1dTIsobN6RPG29fHJ1QR1M5iBk7eXXnl6TY9rtzoO7b0uOStzTX0UpfZczgf2fDjejof4hCAAAAAElFTkSuQmCC'
                    if (p.data.onlineState == 0) return 'image://data:image/png;base64,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'
                    if (p.data.onlineState == 2) return 'image://data:image/png;base64,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'
                }
            },
            symbolSize: 23,
            data: p.data,
        }]
    }
    myChart.on('click', function(params) {
        if (params.seriesType === "scatter") {
            //  if (params.data.type1 == 'person') {
            //      p._this.$router.push({
            //          path: '/personbigScreen',
            //          query: {...params.data }
            //      })
            //  } else {
            //      p._this.$router.push({
            //          path: '/GdbigScreen',
            //          query: {...params.data }
            //      })
            //  }
        }
    })

    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })

};

//销售页面近12月销售量折线图
export const xiaoshouLine = function(option, companyList) {
    var myChart = echarts.init(document.querySelector(option.doc));
    var color = ['#EDB941', '#6D9E7B', '#AD454E', '#7194F3', '#BC857E', '#bf0000', '#01A484'];
    var scaleList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    var dataList = [];
    companyList.forEach(function(item, i) {
        var temp = {
            name: item.name,
            type: 'line',
            symbol: 'none',
            //smooth: true,
            lineStyle: {
                color: color[i],
                width: 1.5
            },
            label: {
                show: true,
                position: 'top',
                textStyle: {
                    color: color[i],
                }
            },
            itemStyle: {
                color: color[i],
                borderWidth: 2,
            },
            data: item.saleChartValue.reverse()
        }
        scaleList = item.saleChartDate.reverse()
        dataList.push(temp);
    });

    var option = {
        tooltip: {
            trigger: 'axis',
        },
        grid: {
            top: '28%',
            left: '0%',
            right: '2%',
            bottom: '0%',
            containLabel: true
        },
        title: {
            text: '近12个月销售量曲线',
            textStyle: {
                fontSize: 15,
                color: '#fff',
                lineHeight: 20,
                itemGap: 100
            },
        },
        legend: {
            type: 'scroll',
            show: true,
            x: 'right',
            y: '22',
            icon: 'stack',
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
                color: '#fff',
                fontSize: 11
            },
        },
        xAxis: [{
            type: 'category',
            minInterval: 5,
            axisLine: {
                show: true,
                color: '#fff',
                lineStyle: {
                    color: '#fff',
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: '#fff',
                width: 100,
            },
            splitLine: {
                show: false
            },
            boundaryGap: false,
            data: scaleList
        }],

        yAxis: [{
            type: 'value',
            minInterval: 1,
            show: true,
            splitNumber: 4,
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dashed',
                    color: '#fff',
                    opacity: .5
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#fff',
                }
            },
            axisLabel: {
                show: true,
                margin: 5,
                textStyle: {
                    color: '#fff',
                },
            },
            axisTick: {
                show: false,
            },
        }],
        series: dataList
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//销售页中国地图热力图
export const xiaoshouMap = (p, list) => {
    var myChart = echarts.init(document.querySelector(p.doc));

    var addressList = [];
    list.forEach(function(item) {
        var address = {
            name: item.areaName,
            value: item.areaCount
        }
        addressList.push(address)
    });
    var option = {
        title: {
            text: '全 国 销 量 热 力 图',
            textStyle: {
                color: '#fff',
            },
            left: '40%',
            top: '5%'
        },
        tooltip: {
            trigger: 'item',
            formatter: function(params) {
                if (!params.value) {
                    return params.name + ' : ' + '0'
                } else {
                    return params.name + ' : ' + params.value
                }
            }
        },
        geo: {
            silent: false,
            map: 'china',
            zoom: 1.24,
            animation: true,
            label: {
                show: false,
            },
            roam: false,
            itemStyle: {
                normal: {
                    areaColor: 'rgba(0,255,255,0)',
                    borderColor: '#fff',
                    borderWidth: 1.5,
                    shadowColor: 'rgba(0,255,255,0)',
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 10,
                },
                emphasis: { // 也是选中样式
                    borderWidth: 2,
                    borderColor: '#fff',
                    areaColor: 'rgba(0, 255, 255, 0.1)',
                    label: {
                        show: false,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                }
            }
        },
        visualMap: {
            type: 'piecewise',
            min: 1, // 颜色映射对应的最小值，即对应下面的lightskyblue
            max: 500, // 颜色映射对应的最大值，即对应下面的orangered
            realtime: true, // 是否显示拖拽手柄，映射条可以拖拽调整要映射的范围
            bottom: 60,
            left: 10,
            inRange: {
                color: ['#40B337', '#447FE6', '#EDB941', '#BF0000', '#820000'] // 颜色映射范围，最小值，过渡值，最大值
            },
            itemHeight: 11,
            textStyle: {
                color: 'white',
                fontSize: 10,
                height: 200
            },
            pieces: [{
                    min: 100,
                },
                {
                    min: 70,
                    max: 100
                },
                {
                    min: 40,
                    max: 70
                },
                {
                    min: 10,
                    max: 40,
                },
                {
                    max: 10,
                }
            ]
        },
        series: [{
            name: '',
            zoom: 1.2,
            type: 'map',
            map: 'china',
            geoIndex: 0,
            label: {
                show: false,
            },
            roam: true,
            animation: true,
            data: addressList,
        }]
    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })

};

//销售页面客户性质画像饼图
export const xiaoshouPie1 = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        color: ['#6D9E7B', '#AD454E', '#EDB941', '#7194F3'],
        title: {
            text: p.title,
            bottom: 0,
            left: 'center',
            textStyle: {
                color: '#fff',
                fontSize: 15
            }
        },
        legend: {
            left: 'left',
            bottom: '15%',
            itemWidth: 10,
            itemHeight: 8,
            textStyle: {
                fontSize: 11,
                color: '#fff'
            },
            left: 'center'
        },
        series: [{
            name: '',
            type: 'pie',
            radius: '60%',
            top: '-25%',
            hoverAnimation: false,
            labelLine: {
                show: false
            },
            label: {
                position: 'inside',
                formatter: '{d}%'
            },
            data: p.data
        }]
    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//销售页面客户性质画像环图
export const xiaoshouPie2 = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        color: ['#6D9E7B', '#AD454E', '#EDB941', '#7194F3'],
        title: {
            text: p.title,
            bottom: 0,
            left: 'center',
            textStyle: {
                color: '#fff',
                fontSize: 15
            }
        },
        legend: {
            left: 'left',
            bottom: '15%',
            itemWidth: 10,
            itemHeight: 8,
            textStyle: {
                fontSize: 11,
                color: '#fff'
            },
            left: 'center'
        },
        series: [{
            name: '',
            type: 'pie',
            radius: ['30%', '60%'],
            top: '-25%',
            hoverAnimation: false,
            labelLine: {
                show: false
            },
            label: {
                position: 'inside',
                formatter: '{d}%'
            },
            data: p.data
        }]
    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//收款页面环图
export const shoukuanPie = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var color = [];
    if (p.type == 1) {
        color = ['#7194F3', '#AD454E']
    }
    if (p.type == 2) {
        color = ['#6D9E7B', '#EDB941']
    }
    if (p.type == 3) {
        color = ['#EDB941', '#6D9E7B']
    }
    if (p.type == 4) {
        color = ['#AD454E', '#7194F3']
    }
    var option = {
        color: color,
        title: {
            text: p.text,
            left: 'center',
            top: 'center',
            textStyle: {
                color: color[0],
                fontSize: 25,
            },
        },
        series: [{
            name: '',
            type: 'pie',
            radius: ['47%', '90%'],
            center: ['50%', '50%'],
            top: '0%',
            bottom: '0%',
            hoverAnimation: false,
            labelLine: {
                show: false
            },
            label: {
                position: 'inside',
                formatter: '{b}\n{c}',
                textStyle: { lineHeight: 13 }
            },
            data: p.data
        }]
    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//收款页面漏斗图
export const shoukuanLoudou = function(p, list) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var companyList = [];
    var dataList = [];
    var option = {
        color: ['#EDB941', '#6D9E7B', '#7194F3', '#AD454E', '#01A484'].reverse(),
        series: [{
            name: '',
            type: 'funnel',
            left: '40%',
            top: '4%',
            bottom: '4%',
            width: '50%',
            gap: 0,
            sort: 'ascending',
            label: {
                normal: {
                    position: 'left',
                    formatter: function(obj) {
                        if (obj.data.reveal == 0) {
                            return obj.data.name.slice(0, 2) + ': ' + obj.data.number
                        } else {
                            return obj.data.name + ': ' + obj.data.number
                        }
                    },
                    textStyle: {
                        fontSize: 13
                    }
                },
            },
            labelLine: {
                normal: {
                    show: true,
                    length: 60,
                }
            },
            itemStyle: {
                normal: {
                    show: false,
                    opacity: 0.2
                }
            },
            data: p.data,
        }, {
            name: '',
            type: 'funnel',
            left: '40%',
            right: '0%',
            top: '4%',
            bottom: '4%',
            width: '50%',
            gap: 0,
            sort: 'ascending',
            label: {
                normal: {
                    position: 'inside',
                    formatter: function(obj) {
                        return obj.data.reveal + '%'
                    },
                    textStyle: {
                        color: '#fff',
                        fontSize: 13
                    }
                },
            },
            itemStyle: {
                normal: {
                    opacity: 1,
                    borderColor: '',
                    borderWidth: 0
                }
            },
            data: p.data,
        }]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//服务页面环图
export const fuwuPie = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var color = [];
    if (p.type == 1) {
        color = ['#7194F3', '#AD454E']
    }
    if (p.type == 2) {
        color = ['#6D9E7B', '#EDB941']
    }
    if (p.type == 3) {
        color = ['#EDB941', '#6D9E7B']
    }
    if (p.type == 4) {
        color = ['#AD454E', '#7194F3']
    }
    var option = {
        color: color,
        title: {
            text: p.text,
            left: 'center',
            top: 'center',
            textStyle: {
                color: color[0],
                fontSize: 25,
            },
        },
        series: [{
            name: '',
            type: 'pie',
            radius: ['47%', '90%'],
            center: ['50%', '50%'],
            top: '0%',
            bottom: '0%',
            hoverAnimation: false,
            labelLine: {
                show: false
            },
            label: {
                position: 'inside',
                formatter: '{b}\n{c}',
                textStyle: { lineHeight: 13 }
            },
            data: p.data
        }]
    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//服务页面近一年报修情况发生曲线
export const fuwuLine = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        tooltip: {
            trigger: 'axis',
        },
        grid: {
            top: '25%',
            left: '0%',
            right: '2%',
            bottom: '0%',
            containLabel: true
        },
        title: {
            text: '近一年报修情况发生曲线',
            top: 5,
            textStyle: {
                fontSize: 16,
                color: '#fff',
                lineHeight: 20,
                itemGap: 100,
            },
        },
        xAxis: [{
            type: 'category',
            minInterval: 5,
            axisLine: {
                show: true,
                color: '#fff',
                lineStyle: {
                    color: '#fff',
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: '#fff',
                width: 100,
            },
            splitLine: {
                show: false
            },
            boundaryGap: false,
            data: p.date.reverse()
        }],

        yAxis: [{
            type: 'value',
            minInterval: 1,
            show: true,
            splitNumber: 4,
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dashed',
                    color: '#fff',
                    opacity: .5
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#fff',
                }
            },
            axisLabel: {
                show: true,
                margin: 5,
                textStyle: {
                    color: '#fff',

                },
            },
            axisTick: {
                show: false,
            },
        }],
        series: [{
            name: '报修',
            type: 'line',
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: 2,
            lineStyle: {
                normal: {
                    color: "#EDB941",
                    width: 1.5
                },
            },
            label: {
                show: true,
                position: 'top',
                textStyle: {
                    color: '#EDB941',
                }
            },
            itemStyle: {
                color: "#fff",
                borderColor: "#7194F3",
                borderWidth: 2,
            },
            areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#EDB941'
                        },
                        {
                            offset: 1,
                            color: 'rgba(225, 176, 63, 0)'
                        }
                    ], false),
                }
            },
            data: p.data.reverse()
        }, ]
    };
    myChart.setOption(option);
    // window.addEventListener('resize', function() {
    //     myChart.resize()
    //     myChart.clear()
    //     myChart.setOption(option);
    // })
}

//服务页面近一年网点承担维修任务柱图
export const fuwuBar = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        title: {
            text: '近一年各网点承担维修任务对比',
            top: 5,
            textStyle: {
                fontSize: 16,
                color: '#fff',
                lineHeight: 20,
                itemGap: 100,
            },
        },
        grid: {
            top: '25%',
            left: '0%',
            right: '2%',
            bottom: '0%',
            containLabel: true
        },
        tooltip: {
            trigger: "item",
        },
        xAxis: {
            type: 'category',
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ccc'
                }
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: true,
                color: 'white',
                margin: 5,
                fontSize: 12,
            },
            data: p.date
        },
        yAxis: {
            type: 'value',
            show: true,
            splitLine: {
                show: false,
            },
            minInterval: 1,
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: true,
                color: 'white',
                interval: 0
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ccc'
                }
            },
        },
        series: [{
            type: 'bar',
            barWidth: 21,
            itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#7194F3'
                    },
                    {
                        offset: 1,
                        color: 'rgba(0, 0, 0, 0.1)'
                    }
                ], false),
            },
            data: p.data
        }]
    };
    myChart.setOption(option);
    // window.addEventListener('resize', function() {
    //     myChart.resize()
    //     myChart.clear()
    //     myChart.setOption(option);
    // })
}

//服务页中国地图
export const fuwuMap = (p) => {
    var myChart = echarts.init(document.querySelector(p.doc));
    var mapName = 'china'
    var chinaGeoCoordMap = {
        '黑龙江': [127.9688, 47.3688],
        '内蒙古': [110.3467, 41.4899],
        "吉林": [125.8154, 44.2584],
        '北京市': [116.4551, 40.2539],
        "辽宁": [123.1238, 42.1216],
        "河北": [114.4995, 38.1006],
        "天津": [117.4219, 39.4189],
        "山西": [112.3352, 37.9413],
        "陕西": [109.1162, 34.2004],
        "甘肃": [103.5901, 36.3043],
        "宁夏": [106.3586, 38.1775],
        "青海": [101.4038, 36.8207],
        "新疆": [87.9236, 43.5883],
        "西藏": [91.11, 29.97],
        "四川": [103.9526, 30.7617],
        "重庆": [108.384366, 30.439702],
        "山东": [117.1582, 36.8701],
        "河南": [113.4668, 34.6234],
        "江苏": [118.8062, 31.9208],
        "安徽": [117.29, 32.0581],
        "湖北": [114.3896, 30.6628],
        "浙江": [119.5313, 29.8773],
        "福建": [119.4543, 25.9222],
        "江西": [116.0046, 28.6633],
        "湖南": [113.0823, 28.2568],
        "贵州": [106.6992, 26.7682],
        "云南": [102.9199, 25.4663],
        "广东": [113.12244, 23.009505],
        "广西": [108.479, 23.1152],
        "海南": [110.3893, 19.8516],
        '上海': [121.4648, 31.2891],
        "成都": [102.9526, 30.7617],
    };
    /*获取地图数据*/
    myChart.showLoading();
    var mapFeatures = echarts.getMap(mapName).geoJson.features;
    myChart.hideLoading();

    mapFeatures.forEach(function(v) {
        // 地区名称
        var name = v.properties.name;
        // 地区经纬度
        chinaGeoCoordMap[name] = v.properties.cp;
    });

    var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            var dataItem = data[i];
            var fromCoord = chinaGeoCoordMap[dataItem[0].name];
            var toCoord = [104.4648, 31.2891];
            if (fromCoord && toCoord) {
                res.push([{
                    coord: toCoord,
                }, {
                    coord: fromCoord,
                    value: dataItem[0].value
                }]);
            }
        }
        return res;
    };
    var option = {
        title: {
            text: '报 修 中 设 备 分 布 图',
            textStyle: {
                color: '#fff',
            },
            left: '40%',
            top: '5%'
        },
        tooltip: {
            trigger: 'item',
            formatter: function(params) {
                if (params.data.type == 1) {
                    return `<div style='padding:10px;line-height:26px;color:#EDB941'>
                        <p>网点名称：${params.data.name}</p>
                        <p>网点地址：${params.data.address}</p>
                        <p>联系人员：${params.data.linker}</p>
                        <p>联系电话：${params.data.linkerTel}</p>
                    </div>`
                } else {
                    return `<div style='padding:10px;line-height:26px;color:#EDB941'>
                        <p>客户名称：${params.data.name || '-'}</p>
                        <p>报修地址：${params.data.repairAddress}</p>
                        <p>报修人员：${params.data.repairPerson}</p>
                        <p>报修电话：${params.data.repairPersonTel}</p>
                        <p>报修时间：${params.data.repairTime}</p>
                        <p>报修内容：${params.data.repairContent}</p>
                    </div>`
                }
            }
        },
        color: ['#7194F3'],
        geo: {
            //aspectScale: 0.7,
            silent: false,
            map: mapName,
            zoom: 1.24,
            //top: '10%',
            //bottom: '10%',
            animation: true,
            label: {
                normal: {
                    show: false,
                    textStyle: {
                        color: '#fff'
                    }
                },
                emphasis: {
                    textStyle: {
                        color: '#fff'
                    }
                }
            },
            roam: false,
            itemStyle: {
                normal: {
                    areaColor: 'rgba(0,255,255,0)',
                    borderColor: '#fff',
                    borderWidth: 1.5,
                    shadowColor: 'rgba(0,255,255,0)',
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 10,
                },
                emphasis: { // 也是选中样式
                    borderWidth: 2,
                    borderColor: '#fff',
                    areaColor: 'rgba(0, 255, 255, 0.1)',
                    label: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                }
            }

        },
        series: [{
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            symbol: function(e, p) {
                if (p.data.type == 1) {
                    return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAeCAYAAADHJYVoAAADyElEQVRIS52VW4gbZRTH/+fL7HbdZLItGwRRqqJgoYtt13ZbL636Ivigb0WoVqgPFdzJ5rJFUdl22kVF6SaTZFbQBwWLRembPgi+qK23dtdeZAstbVGLF5CUbmaSut1NviMz24m5TNLEPIXvf87v/OfMmfMR2vzGD1oR7qMdDH4SLNaB+FY3nOlvkDxDoC9ogQ9P7Qnn/TDkd6h/yH1XS/aEgIgBHGxnAKCShMysCqqT+i5aqI1tgsfTV++ConxOhCEf6JUbZ4ONGjPmUC4/ZSRW/eppdfBo9todAap8R4TVtckMXGLghYymHnXOY6a9jYAPCLinLo5xucKBh3Nj/b8751W4rrMyHyl9T+BN9WC6pnBg6GD0ll9qz/fk/rm7TJU5Avc3xM+szAcf0nUqV+Fxs5gk8FRzK/hQWgs/79f3hGl9BNDOphaBxg0tlHLhu/U/+4MR9TcAkcZAYuxPRVXdD57M2ToT9vlo+VLevtOFx3KF5wSJQy2m4nBaU5/1d25/DGCHnyZZ7nTh8Zz9CRGe8YfTghRyfeal8PlaPfaudZ+Q4jTAfX55zPjUhSdM+wKAe1vNMzNfQjmw1UgE/3LNpEu3QakcI6K6aWnIv+jBneFf4QOvAGwsAm9Na2Fvxt2wUdMa7AVeBSgOIOCTe92Dc7NIi5Ll9kw0/FmrJ1p+X9bTgsQRgHubhuFGW+YBDNTPq0wY2oDRDuxpcbMQJ4h0Q2xh2XnOmgHRxqrIfG7girpW10l2Atd1FoVB+yyI1tQwZpenJWtNkaCkJzDTK0Y09E4n4Kr7XPFlIn67ypC8/BHFjMJmoYgfPUEQb50aDX/bDXx82npEMh3zcmRZbqn5/O1vCNjmiCTFcGoseKobeDJb2sBCnnRyGDhqaOqjVbgrkjwBggJGGUTlbuBgVrxcYjHimKtbucmcfYAJE11BG4KJMZmKqnvdDtRq2/WzvbdHVs8QcP//KcDAz3/kL286oq9dbIK7k2PODxMCzsvt6bLAEqOyxdBWun33hbsFpu19xPBds60KMkE3RtX9tbrvBb37Pe4JLhVPAFjfofvTpZ7QyPsv0tJN4U5AMltcx8TO9DTtjLqCjEViGkmNhc40GvF1/t9XZ08Q4UA798zYa0TVSb+YtnDn0i5EiscBDLcocHIgH9rsXMZdw52EsYw9FAhg1mffX69UsDEbU+daPVlb515SwrReA+iNegi/ntbCb7ZrWUfwx/SvlA2RB34AvLXMs6fyPz34tf542xXREdxxp+WsNT1EXzr/l5ifMKPhczcb038BKjRo/LEOXX8AAAAASUVORK5CYII='
                } else {
                    return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAeCAYAAAAo5+5WAAAC6ElEQVRIS53WzW9UZRTH8c/TFjAiYUMaF76wcKFGRUkpVROdmQqJJmwx8eVfUFN3CoKi7rAx+h+YGHXhQmIIonOrpiqUoBA1JhIVwoqUKCDR0trHPL1zm9vp3M6UZ3fP+Z3vc+55zj33CSpWxqbAU5HHA1sig0kauBA5FTgceb/OdCdEaDdm3BDZG3ge66s2btmvRt4OHKjzb1m7BJyxGYdwTxdgu/tH7KrzR+FYBGfcEpkM3LZK6II8ci7wcJ3zrZKRMYBvsK2042V8GXPbzT1uNoWH6swtZNxkLHCwCI78FmmMcvYoGweYwP29wCMvNngrHOLGmziLTSXwSINjxfPn3N3PafT3AJ/+m9tDxjN4rxxQoz8wX7ZlOfjeHsBJ8mxo8kHgyXLAPJtTGQrbJIPXOIMNvYAjH6aMf8UdbT34XI13CtsEY7F0Bj3AzyRwaux1beLf/+GuJ5hJ9tQ1kU8DO3uAJslMAsdO4sC+Gq8VviOsX8cnqVswiSuRHaHiQBP4L2zsAJ8NjNb4uvCdYM0lHhvlcOtNhvAxbm2Lv5TAqamToNOajtQa/FRVgiaPhrzPF1dgKnXFwcBYVWDkYh+7anzbSdP6Dq6WfTF9IE22B77rcigz8+y5yPhu/mvr7xcw3gYeWfikJ/KZ8Ei3E4/8HBjv48g8f+JpvCufNQsr8FUtLw9HeWCA42VBt00q/HNzDO/g+/LYPIA91wkswl6vs7eVeW77iLWDTEXuux544PQFtu3m2hJweviCrX35Qa5ZJXx2npFRTpZqvRSRsQ/7VwneX+fVcsyyn2n6uq7kB9nTYMcPGxgeYnZFcHI22YLjgbUrZR7zeg43ONWuW5ZxIWjmV4DFIdRpg8grDVI3LVuV4DQqA8ciWysCT0a2px/nqsBJnOX3ixMd5nWa00N10n2i46rMuFSSlwJvlKMjLzd4c6X6dwW37hxpshWjNb3Bg1UlqOzjTllk3InPWr6ddX7p1uf/A2LIv+UaRKTjAAAAAElFTkSuQmCC'
                }
            },
            symbolSize: [20, 25],
            data: p.data,
        }]
    }
    myChart.on('click', function(params) {
        if (params.seriesType === "scatter") {

        }
    })

    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })

};

//设备详情页图
export const devicePei = (p) => {
    var myChart = echarts.init(document.querySelector(p.doc));
    var data = Number(p.data);
    var max = data + 100;
    var flag = p.status;
    var option = {
        series: [{
                name: "内部（环形）进度条",
                type: "gauge",
                center: ['50%', '58%'],
                radius: '67%',
                splitNumber: 0,
                axisLine: {
                    lineStyle: {
                        color: [
                            [data <= 0 ? 0 : (data / max), flag ? '#AD454E' : '#7194F3'],
                            [1, "rgba(113, 148, 243, 0.2)"]
                        ],
                        width: 10
                    }
                },
                title: {
                    show: false,
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                splitLine: {
                    show: false,
                },
                pointer: {
                    show: false,
                },
                detail: {
                    show: false,
                },
            },
            {
                name: '外部刻度',
                type: 'gauge',
                center: ['50%', '58%'],
                radius: '80%',
                min: 0, //最小刻度
                max: max, //最大刻度
                splitNumber: 10, //刻度数量
                startAngle: 225,
                endAngle: -45,
                axisLine: {
                    show: true,
                    // 仪表盘刻度线
                    lineStyle: {
                        width: 2,
                        color: [
                            [1, flag ? '#AD454E' : '#7194F3']
                        ]
                    }
                },
                //仪表盘文字
                axisLabel: {
                    show: false,
                },
                //刻度标签。
                axisTick: {
                    show: true,
                    splitNumber: 7,
                    lineStyle: {
                        color: flag ? '#AD454E' : '#7194F3', //用颜色渐变函数不起作用
                        width: 1,
                    },
                    length: -8
                }, //刻度样式
                splitLine: {
                    show: true,
                    length: -12,
                    lineStyle: {
                        color: flag ? '#AD454E' : '#7194F3', //用颜色渐变函数不起作用
                    }
                }, //分隔线样式
                detail: {
                    show: false
                },
                pointer: {
                    show: false
                }
            },
            /*内部*/
            {
                type: 'pie',
                radius: '35%',
                center: ['50%', '58%'],
                z: 8,
                hoverAnimation: false,
                data: [{
                    name: '',
                    value: data,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: flag ? '#000' : '#000'
                            }, {
                                offset: 1,
                                color: flag ? '#AD454E' : '#7194F3'
                            }])
                        }

                    },
                    label: {
                        normal: {
                            formatter: function(params) {
                                return params.value;
                            },
                            color: '#FFFFFF',
                            fontSize: 23,
                            position: 'center',
                            show: true
                        }
                    },
                    labelLine: {
                        show: false
                    }
                }],
            },
            /*外一层*/
            {
                type: "pie",
                radius: "45%",
                startAngle: 220,
                endAngle: -40,
                hoverAnimation: false,
                center: ["50%", "58%"],
                avoidLabelOverlap: false,
                z: 0,
                labelLine: {
                    show: false
                },
                data: [{
                    value: 0,
                    itemStyle: {
                        normal: {
                            color: flag ? '#AD454E' : 'rgba(113, 148, 243, 0.5)'
                        }
                    }
                }],
            },
            //外二层圈
            {
                type: "pie",
                radius: "60%",
                center: ["50%", "58%"],
                avoidLabelOverlap: false,
                z: 0,
                hoverAnimation: false,
                labelLine: {
                    show: false
                },
                data: []
            }
        ]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//公司详情饼图
export const companyPie = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var color = ['#EDB941', '#7194F3'];
    var option = {
        color: color,
        title: {
            text: p.text,
            left: 'center',
            top: 'center',
            textStyle: {
                color: color[0],
                fontSize: 25,
            },
        },
        series: [{
            name: '',
            type: 'pie',
            radius: ['47%', '90%'],
            center: ['50%', '50%'],
            top: '0%',
            bottom: '0%',
            hoverAnimation: false,
            labelLine: {
                show: false
            },
            label: {
                position: 'inside',
                formatter: '{b}\n{c}',
                textStyle: { lineHeight: 13 }
            },
            data: p.data
        }]
    }
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//公司详情柱图
export const companyBar = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        title: {
            text: '历年购买量变化柱图',
            textStyle: {
                fontSize: 15,
                color: '#fff',
                lineHeight: 20,
                itemGap: 100
            },
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            transitionDuration: 0,
        },
        legend: {
            show: true,
            right: '5px',
            top: '2%',
            itemWidth: 9,
            itemHeight: 9,
            textStyle: {
                color: 'white',
                fontSize: 12
            },
        },
        grid: {
            left: '0%',
            right: '1%',
            bottom: '1%',
            top: '24%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ccc'
                }
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: true,
                color: 'white',
            },
            data: p.date.reverse(),
        },
        yAxis: {
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dashd',
                    color: '#ccc',
                    opacity: .6
                }
            },
            type: 'value',
            minInterval: 1,
            show: true,
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: true,
                color: 'white',
                interval: 0
            },
            axisLine: {
                lineStyle: {
                    color: '#ccc'
                }
            },
            data: []
        },
        series: [{
                label: {
                    show: false,
                    position: ['4%', '20%'],
                    color: 'white'
                },
                name: '塔机',
                type: 'bar',
                barWidth: 12,
                barCategoryGap: 10,
                itemStyle: {
                    opacity: 0.9,
                    color: '#EDB941'
                },
                data: p.towerData.reverse(),
            },
            {
                label: {
                    show: false,
                    position: ['4%', '20%'],
                    color: 'white'
                },
                name: '升降机',
                type: 'bar',
                barWidth: 12,
                barCategoryGap: 10,
                itemStyle: {
                    opacity: 0.9,
                    color: '#7194F3'
                },
                data: p.lifterData.reverse(),
            },
        ]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//公司详情折线图
export const companyLine = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        color: ['#EDB941', '#7194F3'],
        tooltip: {
            trigger: 'axis',
        },
        legend: {
            show: true,
            right: '5px',
            top: '2%',
            itemWidth: 9,
            itemHeight: 9,
            textStyle: {
                color: 'white',
                fontSize: 12
            },
        },
        grid: {
            top: '24%',
            left: '0%',
            right: '2%',
            bottom: '0%',
            containLabel: true
        },
        title: {
            text: '近12个月购买量曲线',
            textStyle: {
                fontSize: 15,
                color: '#fff',
                lineHeight: 20,
                itemGap: 100
            },
        },
        xAxis: [{
            type: 'category',
            minInterval: 5,
            axisLine: {
                show: true,
                color: '#fff',
                lineStyle: {
                    color: '#fff',
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: '#fff',
                width: 100,
            },
            splitLine: {
                show: false
            },
            boundaryGap: false,
            data: p.date.reverse(),
        }],

        yAxis: [{
            type: 'value',
            minInterval: 1,
            show: true,
            splitNumber: 4,
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dashed',
                    color: '#fff',
                    opacity: .5
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#fff',
                }
            },
            axisLabel: {
                show: true,
                margin: 5,
                textStyle: {
                    color: '#fff',

                },
            },
            axisTick: {
                show: false,
            },
        }],
        series: [{
            name: '塔机',
            type: 'line',
            // stack: '2',
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: 0,
            lineStyle: {
                normal: {
                    color: "#EDB941",
                    width: 1.5
                },
            },
            label: {
                show: false,
                position: 'top',
                textStyle: {
                    color: '#EDB941',
                }
            },
            areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#EDB941'
                        },
                        {
                            offset: 1,
                            color: 'rgba(225, 176, 63, 0)'
                        }
                    ], false),
                }
            },
            data: p.towerData.reverse(),
        }, {
            name: '升降机',
            type: 'line',
            // stack: '2',
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: 0,
            lineStyle: {
                normal: {
                    color: "#7194F3",
                    width: 1.5
                },
            },
            label: {
                show: false,
                position: 'top',
                textStyle: {
                    color: '#7194F3',
                }
            },
            itemStyle: {
                //color: "#fff",
                borderColor: "#7194F3",
                borderWidth: 2,
            },
            areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#7194F3'
                        },
                        {
                            offset: 1,
                            color: 'rgba(113, 148, 243, 0)'
                        }
                    ], false),
                }
            },
            data: p.lifterData.reverse(),
        }, ]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//公司详情页地图
export const companyMap = (p) => {
    var myChart = echarts.init(document.querySelector(p.doc));
    var mapName = 'china'
    var chinaGeoCoordMap = {
        '黑龙江': [127.9688, 47.3688],
        '内蒙古': [110.3467, 41.4899],
        "吉林": [125.8154, 44.2584],
        '北京市': [116.4551, 40.2539],
        "辽宁": [123.1238, 42.1216],
        "河北": [114.4995, 38.1006],
        "天津": [117.4219, 39.4189],
        "山西": [112.3352, 37.9413],
        "陕西": [109.1162, 34.2004],
        "甘肃": [103.5901, 36.3043],
        "宁夏": [106.3586, 38.1775],
        "青海": [101.4038, 36.8207],
        "新疆": [87.9236, 43.5883],
        "西藏": [91.11, 29.97],
        "四川": [103.9526, 30.7617],
        "重庆": [108.384366, 30.439702],
        "山东": [117.1582, 36.8701],
        "河南": [113.4668, 34.6234],
        "江苏": [118.8062, 31.9208],
        "安徽": [117.29, 32.0581],
        "湖北": [114.3896, 30.6628],
        "浙江": [119.5313, 29.8773],
        "福建": [119.4543, 25.9222],
        "江西": [116.0046, 28.6633],
        "湖南": [113.0823, 28.2568],
        "贵州": [106.6992, 26.7682],
        "云南": [102.9199, 25.4663],
        "广东": [113.12244, 23.009505],
        "广西": [108.479, 23.1152],
        "海南": [110.3893, 19.8516],
        '上海': [121.4648, 31.2891],
        "成都": [102.9526, 30.7617],
    };
    /*获取地图数据*/
    myChart.showLoading();
    var mapFeatures = echarts.getMap(mapName).geoJson.features;
    myChart.hideLoading();

    mapFeatures.forEach(function(v) {
        // 地区名称
        var name = v.properties.name;
        // 地区经纬度
        chinaGeoCoordMap[name] = v.properties.cp;
    });

    var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            var dataItem = data[i];
            var fromCoord = chinaGeoCoordMap[dataItem[0].name];
            var toCoord = [104.4648, 31.2891];
            if (fromCoord && toCoord) {
                res.push([{
                    coord: toCoord,
                }, {
                    coord: fromCoord,
                    value: dataItem[0].value
                }]);
            }
        }
        return res;
    };
    var option = {
        title: {
            text: '产 品 分 布 图',
            textStyle: {
                color: '#fff',
            },
            left: '40%',
            top: '5%'
        },
        tooltip: {
            trigger: 'item',
            formatter: function(params) {
                return `<div style='padding:10px;line-height:26px;color:#EDB941'>
                    <p>设备类型：${params.data.type==1?'塔机':'升降机'}</p>
                    <p>出厂编号：${params.data.factorNo}</p>
                    <p>设备编号：${params.data.machineNo}</p>
                    <p style="display:${params.data.type==1?'block':'none'};">监控主机：${params.data.imei}</p>
                    <p style="display:${params.data.type==2?'block':'none'};">左笼监控：${params.data.imei}</p>
                    <p style="display:${params.data.type==2?'block':'none'};">右笼监控：${params.data.rightImei}</p>
                    <p>购买单位：${params.data.customerName}</p>
                </div>`
            }
        },
        color: ['#7194F3'],
        geo: {
            //aspectScale: 0.7,
            silent: false,
            map: mapName,
            zoom: 1.24,
            //top: '10%',
            //bottom: '10%',
            animation: true,
            label: {
                normal: {
                    show: false,
                    textStyle: {
                        color: '#fff'
                    }
                },
                emphasis: {
                    textStyle: {
                        color: '#fff'
                    }
                }
            },
            roam: false,
            itemStyle: {
                normal: {
                    areaColor: 'rgba(0,255,255,0)',
                    borderColor: '#fff',
                    borderWidth: 1.5,
                    shadowColor: 'rgba(0,255,255,0)',
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 10,
                },
                emphasis: { // 也是选中样式
                    borderWidth: 2,
                    borderColor: '#fff',
                    areaColor: 'rgba(0, 255, 255, 0.1)',
                    label: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                }
            }

        },
        series: [{
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            symbol: function(e, p) {
                if (p.data.type == 1) {
                    return 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeCAYAAADU8sWcAAAFEklEQVRIS7WWa4iUVRjH///zzu6apu7uuGZa4AWlUiSz2A3MZrzsuNKmpiRB+UkMxCCpwIRI+1AEkrJhISalqJmZRZE7s+rOu166WF4wqQRRSUpaZ8Zbu+7uzHv+8aozrbo7u232fnnhPM9zfs/lPM85RJ4vFQtvAjAaRotKp7r78un2RMbOjBLR0CJDLhYwHNAZQu8KOBKMNOzsCagjmw7hiejEeYbmkMC1gs4RnEzoPQDrZVlpHJwonhr/ioT+iyO3wBPR8AxjkCitjO9PxsLfAopCPAZiK6AFwYi77sLuSSO8tK2Gwz+OBrQ9HHYzPXHiBvj5naFQOmN7D6zas8PfLAsPRtzlqbrwUgive1aRsirX9eXNuycNac5oNmTPB23vrZxe2/pvnMjBz0UnPeTQjiqNuFuyG7SH+2upaHiDiOkBqaL/NPdEVu/sjsfKCozztBVarCncMihS19QdJ3gx+mhpWoUjQM5ICx/4RoN0x1k/ipvh2lFVlHJadkMYYIpUURJ2L7SHpHZO6S/rzaVkWIQtN8tvdoiJWPgygTtvEEh+W30G8EVQv0CIZeU0LJP0KsG9kj7vKEIZ9obVHIJxv1OsWFtWFT9+CzwZDX1Iw6GS31JoJPEXhDpJh0GuBHAfgIsArrQz7gugDwQP0EswXABhF6Rakc8SeBAWNTS6BGKphCY4WB6c4kbbO8BkLPwngIE3LALvl0biC6+lHRUGmlUScb/I6iRioSUE3wJ8R/WahAvGsY0WgYmO1cee0ThY3EWiF6x+7uVk9regcKUR9pdE4jW5LCZj4a8JDBZwN4ALBK5IWh+c5q7KwmXtUwOqGnIpTsVCS3QNXi+o3lgk4KAJ4GDP2h9IZwxg+xnLNhg0sVmbi2e6F1N1oTcAlJ06ffmFh58/mPZrfozEEAi9AKVBehQaBB2GOB/EPaTSEr2cx0BAQADQdxK+N+RzVthH6hDBMIjRENZKSAtaYIiPBLRct58JMhmsjE9hIho6RNKPOvdJ2kaLTXC4FsCYTttG+gQWqzo+dBhPi4MZx5gC2bGyOJLVMwG0lFS6Rzqd7f8MGVR03rNaFYy4izuSp3ZNHmtaWs8wEAimC8yVAZPrf7/ltOcbBtmad6Djl8ABOodrzfiC88P7lhMIlEy9NhFvA1yXIRwD6IH6sbPIfZA/rv3/bYBLAA8QaPX6tD1hmgr9i+bXfPCr17KBSivd1T2LnEhaTysMzTBQ6xTIVAyYvPdAMhauzQdXPNQr1com+N62Xeo7uPpgcw/Srigc1cHj2wJfIVCTSaefCRQUrO4q8mQstJ2gKY3EZ/YocgqNogYWtKG6X7WbOLdrwihjAxthWQSqPm/aY+FyQvcGI+62nsGhEYSd48E05jYwfABWGwmsyQdXPBRY3uDaZctgewQHVE5yI6DcHS1xHIDyfK2Wr4XbTcrO1a73eZuk1gxTswZFjjYlah9/hA5rIBpA3+SLvCsHujHhFBV1lDLzSbwpaUUh2ma0oWh9VwfutsCvvuFioSUAlxl49xdH9pzqqtW6AvvybkUOx/kU1q4D9YksJgVPX56dGtrvy/89cgInRY0k03NKp+7/LRENzyPwJIBiUD/dlpr7j7+MMsPap8sRNgAcLuvNs445mZUFLOeLWkhwc4ZakVv3PJvU2eMjp5/o1hM6l/ZULHxKwNDu1CqvjrA1OC0+tzv75ODJaGgvyAndMcpzvwvEO8FK9+Xu7PM3GTygPc4bQeUAAAAASUVORK5CYII='

                } else {
                    return 'image://data:image/png;base64,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'
                }
            },
            symbolSize: 23,
            data: p.data,
        }]
    }
    myChart.on('click', function(params) {
        if (params.seriesType === "scatter") {

        }
    })

    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
};

//异常情况柱图
export const AbnormalBar = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            transitionDuration: 0,
        },
        legend: {
            show: true,
            right: '15px',
            top: '0px',
            itemWidth: 9,
            itemHeight: 9,
            textStyle: {
                color: 'white',
                fontSize: 12
            },
            //icon: "circle"
        },
        grid: {
            left: '2%',
            right: '2%',
            bottom: '1%',
            top: '8.5%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ccc'
                }
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: true,
                color: 'white',
            },
            data: p.date
        },
        yAxis: {
            splitLine: {
                lineStyle: {
                    type: 'dashd',
                    color: '#ccc',
                    opacity: .6
                }
            },
            type: 'value',
            minInterval: 1,
            show: true,
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: true,
                color: 'white',
                interval: 0
            },
            axisLine: {
                lineStyle: {
                    color: '#ccc'
                }
            },
            data: []
        },
        series: [{
                label: {
                    show: false,
                    position: ['4%', '20%'],
                    color: 'white'
                },
                name: '告警',
                stack: '排行',
                type: 'bar',
                barWidth: 15,
                barCategoryGap: 20,
                itemStyle: {
                    opacity: 0.9,
                    color: '#c9141f'
                },
                data: p.alarmData
            },
            {
                label: {
                    show: false,
                    position: ['4%', '20%'],
                    color: 'white'
                },
                name: '违章',
                type: 'bar',
                stack: '排行',
                barWidth: 15,
                barCategoryGap: 20,
                itemStyle: {
                    opacity: 0.9,
                    color: '#EDB941'
                },
                data: p.violationData
            },
        ]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//异常情况饼图
export const AbnormalPie = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        color: ['#bf0000', '#EDB941'],
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)',
            transitionDuration: 0,
        },
        legend: {
            orient: 'vertical',
            bottom: 20,
            orient: 'horizontal',
            itemWidth: 12,
            itemHeight: 9,
            textStyle: {
                color: 'white',
                fontSize: 14,
                padding: [3, 0, 0, 0]
            }
        },
        series: [{
            name: '塔机',
            type: 'pie',
            radius: '70%',
            center: ['50%', '40%'],
            hoverAnimation: false,
            label: {
                show: true,
                position: 'inside',
                color: 'white',
                fontSize: 11,
                formatter: "{d}%"
            },
            labelLine: {
                show: false
            },
            data: [{
                    value: p.alarmData,
                    name: '告警'
                },
                {
                    value: p.violationData,
                    name: '违章'
                },
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}

//异常页面雷达图
export const AbnormalLeida = function(p) {
    var myChart = echarts.init(document.querySelector(p.doc));
    var option = {
        title: {
            show: true,
            text: p.title,
            bottom: 20,
            right: 0,
            left: 'center',
            textStyle: {
                color: p.color,
                fontSize: 16
            }

        },
        tooltip: {
            trigger: 'item',
            position: ['0%', '0%'],
            transitionDuration: 0,
        },
        radar: {
            radius: '60%', //图的大小
            nameGap: '7', //文字与图间隙
            center: ['50%', '40%'],
            lineStyle: {
                type: 'dashed'
            },
            indicator: p.indicator,
            splitArea: {
                show: true,
                areaStyle: {
                    opacity: 0,
                }
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                rotate: 30
            },
            name: { // (圆外的标签)雷达图每个指示器名称的配置项。
                formatter: '{value}',
                textStyle: {
                    fontSize: 13,
                    color: 'white'
                }
            },
        },
        series: [{
            type: 'radar',
            name: '异常',
            symbolSize: 0,
            areaStyle: {
                color: p.color,
                opacity: 0.7
            },
            lineStyle: {
                color: p.color,
                opacity: 0.8,
                width: 1
            },
            data: [{
                value: p.data
            }]
        }]
    };
    myChart.setOption(option);
    window.addEventListener('resize', function() {
        myChart.resize()
        myChart.clear()
        myChart.setOption(option);
    })
}